<template>
	<div
		class="auroraenergy prose max-w-none bg-gray-50 pb-[140px] antialiased sm:pb-[120px]"
	>
		<PartnerHeader />

		<div class="lg:mt-10 lg:min-h-[670px] xl:min-h-[620px]">
			<slot />
		</div>

		<PartnerFooter />
	</div>
</template>

<script setup>
import PartnerHeader from '@/components/headers/PartnerHeader.vue'
import PartnerFooter from '@/components/footers/PartnerFooter.vue'

const route = useRoute()
const runtimeConfig = useRuntimeConfig()

if (!route.meta.disableGenericCanonical) {
	useHead(() => ({
		link: [
			{
				rel: 'canonical',
				href: runtimeConfig.public.APP_URL + route.path,
			},
		],
	}))
}

useSeoMeta({
	title: 'Electric Car Subscription with Aurora Energy | carbar Australia',
	description:
		'Join the car subscription revolution. Carbar offers exclusive use of a car with insurance, rego, servicing & roadside assist for a fixed weekly fee.',
	ogTitle: 'Electric Car Subscription with Aurora Energy | carbar Australia',
	ogDescription: 'No car yards, no salesmen. We do it online!',
	ogUrl: 'https://www.carbar.com.au/partners/auroraenergy',
	ogType: 'website',
	ogImage: 'https://carbar.com.au/assets/email/images/Carbar-OG.jpg',
})
</script>
